var exports = {
  "kL": "AddFriendSheet.module__container___MzFITD",
  "XG": "AddFriendSheet.module__scroller___MzFITD",
  "Qs": "AddFriendSheet.module__content___MzFITD",
  "Y4": "AddFriendSheet.module__requestsSection___MzFITD",
  "Ic": "AddFriendSheet.module__requestsGroup___MzFITD",
  "sg": "AddFriendSheet.module__requestsHeader___MzFITD",
  "vA": "AddFriendSheet.module__requestsList___MzFITD",
  "Jt": "AddFriendSheet.module__requestDivider___MzFITD",
};

module.exports = exports;
